<template>
<div>
  <main-header-nav
    :goBack="goBack"
    :title="'主材用量指标列表'"
    :content="'更新主材用量指标'">
  </main-header-nav>
  <el-card style="width: 500px;margin: 30px auto;padding: 30px 10px 10px 10px;" v-loading="loading">
    <major-material-usage-form
      :form="editForm"
      :type="type"
      :rules="rules"
    >
    </major-material-usage-form>
  </el-card>
</div>
</template>
<script>
import MainHeaderNav from '../common/MainHeaderNav'
import MajorMaterialUsageForm from './MajorMaterialUsageForm'
export default {
  name: 'EditMajorMaterialUsage',

  components: {
    MainHeaderNav, MajorMaterialUsageForm
  },

  data () {
    return {
      type: 'edit',
      rules: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }]
      },
      editForm: {
        name: ''
      },
      loading: false
    }
  },

  methods: {
    goBack () {
      this.$router.replace('/major_materials_usage')
    }
  },

  mounted () {
    var self = this
    this.$data.loading = true
    this.getRequest('/major_materials_usage/' + this.$route.params.id)
      .then(resp => {
        if (resp && resp.result) {
          self.$data.loading = false
          self.$data.editForm = resp.result
        }
      })
  }
}
</script>
<style></style>
